import { Button, DialogActions, DialogContent, DialogContentText } from '@mui/material';
import React from 'react';

const PermanentlyDelete = ({ cancel, confirm, isMap }) => {
  const handleConfirm = () => {
    confirm();
  };

  return (
    <React.Fragment>
      <DialogContent>
        <DialogContentText>
          You are about to Permanently delete this {!!isMap ? 'layer' : 'folder'}. This action is irreversible. Are you
          sure you want to continue?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={cancel} color="inherit">
          Cancel
        </Button>
        <Button onClick={handleConfirm} color="primary">
          Yes
        </Button>
      </DialogActions>
    </React.Fragment>
  );
};

export default PermanentlyDelete;
